const store = {
  userCreated: {
    allIds: [],
    byId: {}
  },
  predefinedTemplates: {
    allIds: [],
    byId: {}
  },
  currentTemplate: {
    url: "",
    documentId: "",
    contentType: "",
    templateId: ""
  }
};
export default store;